import { useEffect, useState } from 'react';
import { crmApi, CampoCustom } from './crmApi';

interface Props {
  session: any;
  entidade: 'lead' | 'contato' | 'negocio' | 'empresa-conta';
  value: Record<string, any>;
  onChange: (v: Record<string, any>) => void;
}

const CamposCustomForm = ({ session, entidade, value, onChange }: Props) => {
  const [campos, setCampos] = useState<CampoCustom[]>([]);

  useEffect(() => {
    crmApi.listarCamposCustom(session, entidade).then(setCampos).catch(() => {});
  }, [entidade]); // eslint-disable-line

  if (campos.length === 0) return null;

  const set = (chave: string, val: any) => onChange({ ...value, [chave]: val });

  return (
    <div className="space-y-3">
      <p className="text-[10px] text-gray-400 uppercase tracking-wide border-t border-gray-100 pt-3">
        Campos personalizados
      </p>
      <div className="grid grid-cols-2 gap-3">
        {campos.map(c => {
          const val = value[c.chave] ?? '';
          return (
            <div key={c.id} className={c.tipo === 'checkbox' ? 'flex items-center gap-2 col-span-1' : ''}>
              {c.tipo !== 'checkbox' && (
                <label className="text-xs text-gray-600">
                  {c.nome}{c.obrigatorio && <span className="text-red-500 ml-0.5">*</span>}
                </label>
              )}

              {c.tipo === 'texto' && (
                <input value={val} onChange={e => set(c.chave, e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm" />
              )}
              {c.tipo === 'numero' && (
                <input type="number" value={val} onChange={e => set(c.chave, e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm" />
              )}
              {c.tipo === 'data' && (
                <input type="date" value={val} onChange={e => set(c.chave, e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm" />
              )}
              {c.tipo === 'select' && (
                <select value={val} onChange={e => set(c.chave, e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white">
                  <option value="">Selecionar…</option>
                  {(c.opcoes || []).map(op => (
                    <option key={op} value={op}>{op}</option>
                  ))}
                </select>
              )}
              {c.tipo === 'checkbox' && (
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={!!val} onChange={e => set(c.chave, e.target.checked)}
                    className="rounded border-gray-300 text-black h-4 w-4" />
                  <span className="text-xs text-gray-700">{c.nome}</span>
                </label>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CamposCustomForm;
